import { render, staticRenderFns } from "./itemModifiers.vue?vue&type=template&id=6b22df0c&scoped=true&"
import script from "./itemModifiers.vue?vue&type=script&lang=js&"
export * from "./itemModifiers.vue?vue&type=script&lang=js&"
import style0 from "./itemModifiers.vue?vue&type=style&index=0&id=6b22df0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b22df0c",
  null
  
)

export default component.exports